import React, {useState} from 'react';

interface ReleaseNotesDisplayProps {
  text: string;
  maxLength?: number;
  className?: string;
  onToggle?: (isExpanded: boolean) => void;
}

const ReleaseNotesDisplay: React.FC<ReleaseNotesDisplayProps> = ({
  text,
  maxLength = 60,
  className = '',
  onToggle,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) {
    return null;
  }

  const shouldTruncate = text.length > maxLength;
  const displayText =
    shouldTruncate && !isExpanded ? text.substring(0, maxLength) + '...' : text;

  const handleToggle = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    onToggle?.(newExpanded);
  };

  return (
    <div className={className}>
      <div
        className={`text-xs text-gray-400 dark:text-gray-500 transition-all duration-200 ${isExpanded ? 'whitespace-pre-wrap' : 'whitespace-pre-line'}`}
      >
        {displayText}
      </div>
      {shouldTruncate && (
        <button
          onClick={handleToggle}
          className="ml-1 text-xs text-blue-500 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 focus:outline-none transition-colors duration-150"
        >
          {isExpanded ? 'show less' : 'show more'}
        </button>
      )}
    </div>
  );
};

export default ReleaseNotesDisplay;
